module.exports = __webpack_public_path__ + "img/discount.e4f8c8f3.svg";